<template>
  <v-select
    outline
    class="soraban-select-field"
    append-icon="expand_more"
    :persistent-hint="true"
    :error-count="1"
    :error-messages="errorMessages"
    :disabled="disabled"
    :label="label"
    :hint="hint"
    :items="items"
    :item-text="itemText || 'text'"
    :item-value="itemValue || 'value'"
    :return-object="returnObject"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    v-bind="$attrs"
    v-model="valueAlias"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    @change="$emit('change', value)"
  ></v-select>
</template>

<script>
export default {
  name: 'SorabanSelect',
  props: {
    value: {
      required: false,
      type: [String, Number, Object, Array],
      default: '',
    },
    itemValue: {
      required: false,
      type: [String, Function],
      default: '',
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    itemText: {
      required: false,
      type: [String, Function],
      default: '',
    },
    returnObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    items: {
      required: true,
      type: Array,
      default: () => [],
    },
    label: {
      required: true,
      default: '',
      type: String,
    },
    errorMessage: {
      required: false,
      type: String || null,
      default: null,
    },
    hint: {
      required: false,
      default: null,
      type: String || null,
    },
  },
  computed: {
    errorMessages() {
      return this.errorMessage ? [this.errorMessage] : null;
    },
    valueAlias: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped lang="postcss">
@media only screen and (max-width: 550px) {
  >>> .v-input__slot {
    margin-left: 0px;
    margin-top: 0px;
    & .v-select__selection {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      max-width: 25ch;
    }
  }
}
</style>
